<template>
  <div>
    <flickity ref="aaa" :options="flickityOptions">
      <div class="carousel-cell" v-for="(item, ix) in bannerList" :key="ix">
        <a
          v-if="
            item.sgL_ImageClickUrl.startsWith('https') ||
            item.sgL_ImageClickUrl.startsWith('http')
          "
          target="_blank"
          :href="item.sgL_ImageClickUrl"
          @click="ck(item.id)"
          ><img :src="item.sgL_ImageUrl" class="d-block w-100" alt=""
        /></a>
        <a
          v-else
          target="_blank"
          :href="`http://${item.sgL_ImageClickUrl}`"
          @click="ck(item.id)"
        >
          <img :src="item.sgL_ImageUrl" class="d-block w-100" alt="" />
        </a>
      </div>
    </flickity>
  </div>
</template>

<script>
import Flickity from "vue-flickity";
export default {
  props: {
    bannerList: null,
  },
  components: {
    Flickity,
  },
  data() {
    return {
      flickityOptions: {
        autoPlay: 4500,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
      },
    };
  },
  methods: {
    init() {},
    ck(id) {
      let params = {
        id,
      };
      this.$api.BannerApi.BannerCk(params).then((data) => {});
    },
  },
};
</script>

<style scoped>
.carousel {
}

.carousel-cell {
  width: 100%;
  height: 200px;
  /* flex-box, center image in cell */
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}

.carousel-cell img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  /* dim unselected */
  opacity: 1;
  -webkit-transform: scale(0.85);
  transform: scale(0.85);
  -webkit-filter: blur(5px);
  filter: blur(5px);
  -webkit-transition: opacity 0.3s, -webkit-transform 0.3s, transform 0.3s,
    -webkit-filter 0.3s, filter 0.3s;
  transition: opacity 0.3s, transform 0.3s, filter 0.3s;
}

/* brighten selected image */
.carousel-cell.is-selected img {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-filter: none;
  filter: none;
}

@media screen and (min-width: 768px) {
  .carousel-cell {
    width: 80%;
    height: 500px;
    padding-top: 60px;
  }
}

@media screen and (min-width: 960px) {
  .carousel-cell {
    width: 75%;
    height: 550px;
    padding-top: 60px;
  }
}

@media screen and (min-width: 1024px) {
  .carousel-cell {
    width: 75%;
    height: 500px;
    padding-top: 100px;
  }
}
@media screen and (min-width: 1240px) {
  .carousel-cell {
    width: 65%;
    height: 520px;
    padding-top: 100px;
  }
}
/* buttons, no circle */
.flickity-prev-next-button {
  width: 60px;
  height: 60px;
  background: transparent;
  opacity: 0.6;
}
.flickity-prev-next-button:hover {
  background: transparent;
  opacity: 1;
}
/* arrow color */
.flickity-prev-next-button .arrow {
  fill: white;
}
.flickity-prev-next-button.no-svg {
  color: white;
}
/* closer to edge */
.flickity-prev-next-button.previous {
  left: 0;
}
.flickity-prev-next-button.next {
  right: 0;
}
/* hide disabled button */
.flickity-prev-next-button:disabled {
  display: none;
}

/*! Flickity v2.2.2
https://flickity.metafizzy.co
---------------------------------------------- */

.flickity-enabled {
  position: relative;
}

.flickity-enabled:focus {
  outline: none;
}

.flickity-viewport {
  overflow: hidden;
  position: relative;
  height: 100%;
}

.flickity-slider {
  position: absolute;
  width: 100%;
  height: 100%;
}

/* draggable */

.flickity-enabled.is-draggable {
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.flickity-enabled.is-draggable .flickity-viewport {
  cursor: move;
  cursor: -webkit-grab;
  cursor: grab;
}

.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}

/* ---- flickity-button ---- */

.flickity-button {
  position: absolute;
  background: hsla(0, 0%, 100%, 0.75);
  border: none;
  color: #333;
}

.flickity-button:hover {
  background: white;
  cursor: pointer;
}

.flickity-button:focus {
  outline: none;
  box-shadow: 0 0 0 5px #19f;
}

.flickity-button:active {
  opacity: 0.6;
}

.flickity-button:disabled {
  opacity: 0.3;
  cursor: auto;
  /* prevent disabled button from capturing pointer up event. #716 */
  pointer-events: none;
}

.flickity-button-icon {
  fill: currentColor;
}

/* ---- previous/next buttons ---- */

.flickity-prev-next-button {
  top: 50%;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  /* vertically center */
  transform: translateY(-50%);
}

.flickity-prev-next-button.previous {
  left: 10px;
}
.flickity-prev-next-button.next {
  right: 10px;
}
/* right to left */
.flickity-rtl .flickity-prev-next-button.previous {
  left: auto;
  right: 10px;
}
.flickity-rtl .flickity-prev-next-button.next {
  right: auto;
  left: 10px;
}

.flickity-prev-next-button .flickity-button-icon {
  position: absolute;
  left: 20%;
  top: 20%;
  width: 60%;
  height: 60%;
}

/* ---- page dots ---- */

.flickity-page-dots {
  position: absolute;
  width: 100%;
  bottom: -25px;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  line-height: 1;
}

.flickity-rtl .flickity-page-dots {
  direction: rtl;
}

.flickity-page-dots .dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 8px;
  background: #333;
  border-radius: 50%;
  opacity: 0.25;
  cursor: pointer;
}

.flickity-page-dots .dot.is-selected {
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/banner.vue